/* unplugin-vue-components disabled */import script from "./GlobalMusicPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalMusicPlayer.vue?vue&type=script&setup=true&lang=js"

import "./GlobalMusicPlayer.vue?vue&type=style&index=0&id=12fb0ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12fb0ecc"]])

export default __exports__